/* @ngInject */
const format = (utils) => {
  const self = {}

  self.user = (_commande) => {
    return _commande
  }

  self.server = (_commande) => {
    const commande = utils.copy(_commande)

    return commande
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/services/format.service.js